module.exports = __webpack_public_path__ + "6cdb415b26b9e384fcb55d0d0bae642d.pdf";